import myaxios from "../../components/Axios";

export const createOpportunityService = ({ data }) => myaxios.post(`/ajax/opportunity`, data)
export const getSingleOpportunityService = ({ id, expand }) => myaxios.get(`/ajax/opportunity/${id}?expand=${expand}`)
export const updateOpportunityService = ({ id, data }) => myaxios.put(`/ajax/opportunity/${id}`, data)
export const deleteOpportunityService = ({ id }) => myaxios.delete(`/ajax/opportunity/${id}`)
export const getOpportunityPrepareService = () => myaxios.get(`/ajax/opportunity/prepare`)
export const getOpportunityListService = ({ expand = "", filter = "", sort = "" }) => myaxios.get(`/ajax/opportunity/`)